import { API_URL } from "../config/api_url";

function getAuthHeaders(extra = {}) {
    const token = localStorage.getItem("access_token");
    return {
        Accept: "application/json",
        Authorization: token ? `Bearer ${token}` : "",
        ...extra,
    };
}

async function request(path, options = {}) {
    const res = await fetch(`${API_URL}${path}`, {
        ...options,
        headers: getAuthHeaders(options.headers || {}),
    });

    if (!res.ok) {
        const text = await res.text().catch(() => "");
        throw new Error(text || `HTTP ${res.status}`);
    }

    const ct = res.headers.get("content-type") || "";
    return ct.includes("application/json") ? res.json() : res.text();
}

export function getUsers() {
    return request("/users", { method: "GET" });
}

export function createUser(payload) {
    return request("/users", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
    });
}

export function updateUser(id, payload) {
    return request(`/users/${id}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
    });
}

export function updateUserPassword(id, payload) {
    return request(`/users/${id}/password`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
    });
}

export function deleteUser(id) {
    return request(`/users/${id}`, {
        method: "DELETE",
    });
}
